import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iSupplierPaymentMethod } from "./supplier-payment-method-model";

export class SupplierPaymentMethodsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.supplierPaymentMethods.configure(config);
  }

  supplierPaymentMethods = new EntityServices<iSupplierPaymentMethod>(
    SDKConfig,
    "supplier-payment-methods",
    {}
  );
}
